import { Component, OnInit, AfterViewInit, ApplicationRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { OperatorService } from '../_services/operator.service';
import { UserAccountService } from '../_services/user-account.service';
import { OperatorModel } from '../_models/operator-model';
import { debounceTime, filter } from 'rxjs/operators';
import { NewUserRequestModel } from '../_models/new-user-request-model';
import { APIOperationResult } from '../_models/apioperation-result';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, AfterViewInit {

  emailAddressForm: FormGroup;
  tellUsAboutForm: FormGroup;
  operatorsForm: FormGroup;

  operatorSearchTimeout: any;

  operatorCandidates: Array<OperatorModel>;
  selectedOperators: Array<OperatorModel> = new Array<OperatorModel>();

  existingEmailCheckTimeout: any;

  emailModel: any = {
    emailAddress: "",
    emailChecked: false,
    emailNotExists: true,
    password: "",
    confirmPassword: ""
  };

  tellUsAboutModel: any = {
    firstName: "",
    lastName: "",
    RRCP5: ""
  };

  operatorsFormModel: any = {
    searchOperatorNumber: "",
    selectedOperators: []
  };

  constructor(protected formBuilder: FormBuilder,
    public userAccountService: UserAccountService,
    public operatorService: OperatorService,
    protected appRef: ApplicationRef,
    protected dialog: MatDialog,
    protected router: Router
  )
  {
    var _this = this;

    function selectedOperatorsValidator() {
      return (control: AbstractControl) => {
        var ret: any = {};

        var operatorsArray = control.value;

        if (operatorsArray.length != null && operatorsArray.length == 0) {
          ret.noOperators = true;
        }

        return ret;
      };
    }

    function passwordValidator() {
      return (control: AbstractControl) => {
        var ret: any = {};

        var password = control.value;

        if (password.length < 8) {
          ret.tooShort = true;
        }

        return ret;
      };
    }

    function confirmPasswordValidator() {
      return (control: AbstractControl) => {
        var ret: any = {};

        var firstPasswordControl = control.get("password");
        var confirmPasswordControl = control.get("confirmPassword");

        if (firstPasswordControl != null && confirmPasswordControl != null) {
          var passwordValue = firstPasswordControl.value;
          var confirmPasswordValue = confirmPasswordControl.value;

          if (passwordValue != confirmPasswordValue) {
            ret.noMatch = "Passwords must match.";
          }
        }
        else {
          ret.error = "Something unexpected went wrong.";
        }

        return ret;
      };
    }

    this.emailAddressForm = this.formBuilder.group({
      'emailAddress': [this.emailModel.emailAddress, [Validators.required, Validators.email]],
      'emailChecked': [this.emailModel.emailChecked, [Validators.requiredTrue]],
      'emailNotExists': [this.emailModel.emailNotExists, [Validators.requiredTrue]],
      'password': [this.emailModel.password, [Validators.required, passwordValidator()]],
      'confirmPassword': [this.emailModel.confirmPassword, [Validators.required]]
    }, {
      validators: confirmPasswordValidator()
    });

    this.tellUsAboutForm = this.formBuilder.group({
      'firstName': [this.tellUsAboutModel.firstName, [Validators.required]],
      'lastName': [this.tellUsAboutModel.lastName, [Validators.required]],
      'phone': [this.tellUsAboutModel.phone, [Validators.required]]
    });

    this.operatorsForm = this.formBuilder.group({
      'searchOperatorNumber': [this.operatorsFormModel.searchOperatorNumber, []],
      'selectedOperators': [this.selectedOperators, [selectedOperatorsValidator()]]
    });
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit() {

    this.operatorsForm.get("searchOperatorNumber").valueChanges.pipe(filter((val) => val.length === 6),
      debounceTime(500)).subscribe((x) => {
        this.updateOperatorSearchResults(x);
    });

  }

  doExistingEmailCheck() {

    var _this = this;

    this.emailAddressForm.get("emailChecked").setValue("false");

    if (!this.emailAddressForm.get("emailAddress").hasError("email")) {

      if (this.existingEmailCheckTimeout != null) {
        clearTimeout(this.existingEmailCheckTimeout);
      }

      this.existingEmailCheckTimeout = setTimeout(function () {
        _this.userAccountService.validateEmail(_this.emailAddressForm.get("emailAddress").value).then((result) => {

          _this.emailAddressForm.get("emailChecked").setValue(true);

          if (result.alreadyExists != null && result.alreadyExists == true) {
            _this.emailAddressForm.get("emailNotExists").setValue(false);
          }
          else {
            _this.emailAddressForm.get("emailNotExists").setValue(true);
          }

          //Force change detection
          _this.appRef.tick();
        },
        (err) => {
        });
      }, 750);
    }
  }

  getEmailAddressErrorMessage() {
    var ret = null;

    if (this.emailAddressForm.get("emailAddress").hasError("required")) {
      ret = "An email address is required for registration.";
    }
    else if (this.emailAddressForm.get("emailAddress").hasError("email")) {
      ret = "Not a valid email address.";
    }

    return ret;
  }

  onStepChange(event: Event) {

  }

  updateOperatorSearchResults(currentVal) {
    //Perform the search
    this.operatorService.searchByP5Number(currentVal).then((operCandidates: Array<OperatorModel>) => {
      this.operatorCandidates = operCandidates;
    },
    (err) => {
    });
  }

  selectOperator(oper) {
    var found = this.selectedOperators.find((x: OperatorModel) => {
      var ret = false;

      if (x.Id == oper.Id) {
        ret = true;
      }

      return ret;
    });

    if (found == null) {
      this.selectedOperators.push(oper);

      this.operatorsForm.get("selectedOperators").setValue(this.selectedOperators);
    }
  }

  removeOperator(oper) {
    var ind = this.selectedOperators.indexOf(oper);

    this.selectedOperators.splice(ind, 1);

    this.operatorsForm.get("selectedOperators").setValue(this.selectedOperators);
  }

  doSubmit() {
    var newUserModel = new NewUserRequestModel();

    //Grab our values and put them into our submit model.
    newUserModel.email = this.emailAddressForm.get("emailAddress").value;
    newUserModel.password = this.emailAddressForm.get("password").value;
    newUserModel.firstName = this.tellUsAboutForm.get("firstName").value;
    newUserModel.lastName = this.tellUsAboutForm.get("lastName").value;
    newUserModel.phone = this.tellUsAboutForm.get("phone").value;

    var operators = this.operatorsForm.get("selectedOperators").value;

    for (var i = 0; i < operators.length; i++) {
      newUserModel.operators.push(operators[i].Id);
    }

    //Submit the new user account...
    this.userAccountService.submitNewUser(newUserModel).then((result: APIOperationResult) => {
      if (result.Success) {

        //If we had a success message, display the confirmation dialog, which talks about how
        this.dialog.open(MessageDialogComponent, {
          data: {
            title: "User Account Created",
            message: "Your user account has been created successfully.  Before you can log in, confirmation is required by you and the designated approver at the operator  you have selected.  An email has been dispatched to the address you gave with instructions regarding how to complete this process.  Please read and follow the instructions it provides carefully."
          }
        }).afterClosed().subscribe(() => {
          //Navigate back to the login page.
          this.router.navigate(['/login']);
        });
      }
      else {
        this.dialog.open(MessageDialogComponent, {
          data: {
            title: "Error",
            message: "An error occurred while attempting to create your account.  You can try clicking on the submit button again, but if this problem persists, you should contact the administrator."
          }
        });
      }
    },
      (err) => {
      });

  }
}
